import Cookies from 'js-cookie';
import type { CookieAttributes } from 'js-cookie';

const attributes: CookieAttributes = { path: '/', sameSite: 'None', secure: true };

// Handle cases where Cookies might be undefined (e.g., in test environments)
// or where withAttributes might not be available
let cookieStore: { get: (key: string) => string | undefined; set: (key: string, value: string, options?: CookieAttributes) => void; remove: (key: string, options?: CookieAttributes) => void };
if (Cookies && typeof (Cookies as { withAttributes?: (attrs: CookieAttributes) => typeof Cookies }).withAttributes === 'function') {
    cookieStore = (Cookies as { withAttributes: (attrs: CookieAttributes) => typeof Cookies }).withAttributes(attributes);
} else if (Cookies) {
    // Fallback: use Cookies directly if withAttributes is not available
    cookieStore = Cookies;
} else {
    // Fallback for test environments where js-cookie might not be available
    // Create a minimal implementation that matches the interface
    cookieStore = {
        get: () => undefined,
        set: () => undefined,
        remove: () => undefined,
    };
}

export default {
    get(key: string): string | undefined {
        return cookieStore.get(key);
    },
    set(key: string, value: string, options: CookieAttributes = {}): void {
        cookieStore.set(key, value, { ...attributes, ...options });
    },
    remove(key: string, options: CookieAttributes = {}): void {
        cookieStore.remove(key, { ...attributes, ...options });
    },
};
